/**
 * Convert a string to headline format matching Laravel's Str::headline().
 * Handles $-prefixed variables (e.g., "$item" → "$Item") which the shared
 * toHeadline utility does not, since PHP's mb_convert_case(MB_CASE_TITLE)
 * title-cases after any non-letter character.
 */
export function headline(input: string): string {
  return input
    .replace(/[_-]/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .split(' ')
    .map((word) =>
      word.replace(/[a-zA-Z]/g, (c, i, str) => {
        const isFirstLetter = !str.slice(0, i).match(/[a-zA-Z]/);
        return isFirstLetter ? c.toUpperCase() : c.toLowerCase();
      })
    )
    .join(' ')
    .trim();
}

export function capitalizeFirst(value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function compactLabel(label: string): string {
  return headline(label).replace(/\s+/g, '');
}

export function studlyType(type: string): string {
  return type
    .split(/[_\s-]+/)
    .flatMap((part) => (part ? [part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()] : []))
    .join('');
}

export function pluralize(count: number, singular: string, plural = `${singular}s`): string {
  return `${count} ${count === 1 ? singular : plural}`;
}
